import { Component, Input, OnInit } from '@angular/core';
import { contains } from 'ramda';
import { first, tap, map } from 'rxjs/operators';
import { ISession } from '../../../../models/session';
import { TagsService } from '../../tags.service';
import { IWidgetOptions } from '../stats';
import { StatsService } from '../stats.service';

@Component({
  selector: 'sessions-stats-number',
  template: `
    <div class="phase-header-title">{{ options.title }}</div>
    <div class="phase-header-num">{{ num }}</div>
  `,
  styleUrls: ['../stats.component.scss']
})
export class StatsNumberComponent implements OnInit {
  @Input('session') session: ISession;
  @Input('options') options: IWidgetOptions;

  public num: number = 0;

  constructor(private statsService: StatsService, private tagService: TagsService) {}

  ngOnInit() {
    if (contains('fileid', this.options.requiredParams || [])) {
      this.tagService.getTag(this.session, 'webevent.global.uploaded_files').subscribe(tags => {
        if (Array.isArray(tags) && tags.length > 0 && tags[0].value) {
          const value = JSON.parse(tags[0].value);
          if (Array.isArray(value) && value.length > 0) {
            this.updateNumber(value[0].id);
          }
        }
      });
    } else {
      this.updateNumber();
    }
  }

  updateNumber(fileid?: string) {
    const options = fileid
      ? {
          params: {
            fileid
          }
        }
      : null;
    const postProcess$ = map((data: any) =>
      this.options.postProcess ? this.options.postProcess(data) : data
    );
    const setData$ = tap((value: any) => (this.num = value));
    const source$ = this.statsService.call(`${this.options.func(this.session.id)}`, options);
    source$.pipe(first(), postProcess$, setData$).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/stats/stats-number/stats-number.component.ts